import { render } from "./battery-item.vue?vue&type=template&id=15ed1650&scoped=true"
import script from "./battery-item.vue?vue&type=script&lang=js"
export * from "./battery-item.vue?vue&type=script&lang=js"

import "./battery-item.vue?vue&type=style&index=0&id=15ed1650&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ed1650"]])

export default __exports__